/**
 * Team Context Utilities
 * Handles localStorage and URL parameter management for team context
 */

const TEAM_CONTEXT_KEY = 'tectra_active_team_context'

/**
 * Get the active team context from localStorage
 * @returns {string|null} Team ID or null for organization context
 */
export const getStoredTeamContext = () => {
  if (typeof window === 'undefined') return null
  const stored = localStorage.getItem(TEAM_CONTEXT_KEY)
  if (!stored || stored === 'org') return null
  return stored
}

/**
 * Store the active team context in localStorage
 * @param {string|null} teamId - Team ID or null for organization context
 */
export const setStoredTeamContext = teamId => {
  if (typeof window === 'undefined') return
  if (!teamId || teamId === 'org') {
    localStorage.setItem(TEAM_CONTEXT_KEY, 'org')
  } else {
    localStorage.setItem(TEAM_CONTEXT_KEY, teamId)
  }
}

/**
 * Parse team context from URL query parameter
 * @param {string} contextParam - URL context parameter (e.g., "team:123" or "org")
 * @returns {string|null} Team ID or null for organization context
 */
export const parseTeamContextFromUrl = contextParam => {
  if (!contextParam) return null
  if (contextParam === 'org') return null
  if (contextParam.startsWith('team:')) {
    return contextParam.substring(5)
  }
  return null
}

/**
 * Format team context for URL query parameter
 * @param {string|null} teamId - Team ID or null for organization context
 * @returns {string} Formatted context string for URL
 */
export const formatTeamContextForUrl = teamId => {
  if (!teamId || teamId === 'org') return 'org'
  return `team:${teamId}`
}
